import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsAccessibilityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_accessibility"}/>
}
